module.exports = __webpack_public_path__ + "static/img/right.4277ded5.png";